import { render, staticRenderFns } from "./rcc-textarea.vue?vue&type=template&id=732d28d1&"
import script from "./rcc-textarea.vue?vue&type=script&lang=js&"
export * from "./rcc-textarea.vue?vue&type=script&lang=js&"
import style0 from "./rcc-textarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports